export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14359.f395a214.jpg";